import { functions } from "config/firebase.config";
import { AuthGate } from "context/AuthGate";
import { connectFunctionsEmulator } from "firebase/functions";
import { Toaster } from "react-hot-toast";
import { BrowserRouter as Router } from "react-router-dom";
import ProtectedRoutes from "routes/ProtectedRoutes";
import PublicRoutes from "routes/PublicRoutes";
import "utils/tokenExporter"; // Load token utilities

// if (typeof window !== "undefined" && window.location.hostname === "localhost") {
//     connectFunctionsEmulator(functions, "localhost", 5001);
// }

const App = () => {
    return (
        <Router>
            <Toaster />
            <AuthGate>
                <PublicRoutes />
                <ProtectedRoutes />
            </AuthGate>
        </Router>
    );
};

export default App;